<!-- @format -->

<template>
  <Flex justify-between items-center gap-3 class="pb-3 border-b">
    <div>
      Código <span class="font-semibold">{{ itemWarehouse.id }}</span>
    </div>
    <div>
      <p class="text-sm">Data Lançamento:</p>
      <span class="font-semibold"> {{ formatDate(itemWarehouse.startDate) }}</span>
    </div>
  </Flex>
  <Flex justify-between items-center gap-3 class="pb-3 border-b">
    <div>
      <p class="text-sm">Status</p>
      <span class="text-xs bg-yellow-200 rounded px-2 py-1" v-if="itemWarehouse.status == 'in_progress'">Em Progresso</span>
      <span class="text-xs bg-green-200 rounded px-2 py-1" v-if="itemWarehouse.status == 'done'">Finalizado</span>
    </div>
    <div>
      <p class="text-sm">Responsável</p>
      <span class="italic">{{ itemWarehouse.userName ?? 'Pendente' }}</span>
      <p class="text-sm" v-if="itemWarehouse.idUserFinisher">Concluído por</p>
      <span class="italic" v-if="itemWarehouse.idUserFinisher">{{ itemWarehouse.userFinisherName ?? 'Pendente' }}</span>
    </div>
    <div>
      <p class="text-sm">Data Conclusão</p>
      <span class="italic">{{ formatDate(itemWarehouse.endDate) ?? 'Pendente' }}</span>
    </div>
  </Flex>
  <TableFull v-model="control" :headers="headers" :items="itemWarehouse.items" dense class="w-full">
    <template v-slot:quantity="{ item }">
      <span v-if="itemWarehouse.status == 'in_progress'">{{ item.quantity }}</span>
      <span v-if="itemWarehouse.status == 'done'">{{ item.reckoning }}</span>
    </template>
    <template v-slot:avgPrice="{ item }">
      <span v-if="itemWarehouse.status == 'in_progress'">{{ formatMoneyS(item.quantity * item.avgPrice) }}</span>
      <span v-if="itemWarehouse.status == 'done'">{{ formatMoneyS(item.reckoning * item.avgPrice) }}</span>
    </template>
  </TableFull>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import { get } from '@/crud'
import { useNavigation } from '@/composables/useNavigation'
import { useFormat } from '@/composables/useFormat'
//  Composables
const { navigate } = useNavigation()
const { formatDate, formatMoneyS } = useFormat()

// Props
const props = defineProps({
  id: [String, Number],
})
// Controller
const api = 'inventory'

const itemWarehouse = ref([])

const control = ref({
  page: 1,
  limit: 20,
  pages: 0,
  total: 0,
  order: [{ direction: 'ASC', column: 'id', name: 'Código' }],
})

const headers = ref([
  { title: 'Código', field: 'code', itemClass: 'w-2/12' },
  { title: 'Item', field: 'itemName', itemClass: '!text-wrap w-6/12' },
  { title: 'Estoque', field: 'quantity', itemClass: 'w-2/12' },
  { title: 'Total', field: 'avgPrice', itemClass: 'w-2/12' },
])

// Methods
const loadItems = async () => {
  const filters = [
    {
      column: 'id',
      value: props.id,
      operator: '=',
    },
  ]

  const query = {
    params: {
      page: control.value.page,
      limit: control.value.limit,
      order: control.value.order,
      filters,
    },
  }

  const raw = await get(api, query)
  itemWarehouse.value = raw.data[0]
  control.value.pages = Math.ceil(raw.total / control.value.limit)
  control.value.total = raw.total
}
// Watchers
watch(
  () => props.id,
  () => {
    loadItems()
  },
  { deep: true },
)

watch(
  () => control.value,
  () => {
    loadItems()
  },
  { deep: true },
)

// Life Cycle
onMounted(() => {
  loadItems(1)
})
</script>
